import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Stack from "@mui/material/Stack";

import actions from "actions";
import MatchingCalendar from "./MatchingCalendar";
import MatchPanel from "./MatchingPanel";
import RefreshDialog from "./RefreshDialog";
import BCBACaseload from "./MatchingPanel/BCBACaseload";
import { MatchingProvider } from "./MatchingProvider";

function Matching() {
  const dispatch = useDispatch();
  const [showCaseload, setShowCaseload] = useState(false);

  useEffect(() => {
    dispatch(
      actions.setPageDetails({
        pageName: "Matching",
        currentPage: "matching",
        menu: "matchingHome",
      })
    );
  }, [dispatch]);

  return (
    <MatchingProvider>
      <Stack
        direction="row"
        component="main"
        width="100%"
        // 131px and 156px are fixed values for toolbar height for different screen
        height={{ xs: "calc(100vh - 156px)", lg: "calc(100vh - 131px)" }}
      >
        {showCaseload ? (
          <BCBACaseload setShowCaseload={setShowCaseload} />
        ) : (
          <MatchPanel setShowCaseload={setShowCaseload} />
        )}

        <MatchingCalendar />

        <RefreshDialog />
      </Stack>
    </MatchingProvider>
  );
}

export default Matching;
